export default {
	questions_about_the_program_find_yout_answers_here: "¿Tienes alguna duda, sugerencia, crítica o elogio acerca del programa Intel Te Premia? ¡Contáctanos!"
}
